<template>
    <div class="container">
        <div class="topBg">
            <mt-swipe ref="swipe" :auto="0" @change="handleChange" :show-indicators="false" >
                <mt-swipe-item v-for="(item,index) in biaoList" :key="index">
                    <div class="swiper_bg">
                        <div class="swiper_top">
                            <div class="swiper_top_item1">
                                <span class="swiper_top_span1">仪表号</span>
                                <span class="swiper_top_span2">{{item.meterNo}}</span>
                            </div>
                            <div class="swiper_top_item2">
                                <span class="swiper_top_span1">仪表名</span>
                                <span class="swiper_top_span2">{{item.name}}</span>
                            </div>
                            <span class="swiper_top_span3">{{index+1}}/{{biaoList.length}}</span>
                        </div>
                        <div class="swiper_footer">
                            <span class="swiper_top_span4">{{item.merchantName}}</span>
                            <span class="swiper_top_span5">{{item.storeNo}}</span>
                        </div>

                    </div>
                </mt-swipe-item>
            </mt-swipe>
            <img @click="changeSwipeIndex(-1)"
                    class="prevIcon"
                    src='../../assets/images/btn_coupon_last@2x.png'/>
            <img @click="changeSwipeIndex(1)"
                    class="nextIcon"
                    src='../../assets/images/btn_coupon_next@2x.png'/>

        </div>
        <div class="chooseview">
             <span class="chooseSpan" @click="showPickView()">{{year}}</span>
             <img class="chooseIcon" @click="showPickView()" src="../../assets/images/icon_arrows_unfold@2x.png"/>
             <div class="chooseDiv" @click="toUseDetailed()">
                 <span class="chooseSpan1">明细</span>
                 <img class="chooseIcon1" src='../../assets/images/icon_indicator_next.png'/>
             </div>
        </div>
        <div class="yearAmountView">
            <span class="yearAmountSpan1">年耗电量</span>
            <div class="yearAmountdiv">
                <span class="yearAmountSpan2">{{allAmountInt}}</span>
                <span class="yearAmountSpan3">{{'.'+ allAmountDif +'    度'}}</span>
            </div>
        </div>

        <div class="barViewBg">
            <div class="chart" ref="chart"></div>
        </div>


           <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
        <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
            <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
                <div class="picker_wrap">
                    <div class="picker_btn" @click="popupVisible=false">取消</div>
                    <div class="picker_btn2" @click="handleConfirm">确认</div>
                </div>
            </mt-picker>
        </mt-popup>


    </div>
</template>

<script>
import util from "../../utils/util";
import storage from '../../utils/storage';
import { mapState,mapActions } from "vuex";
import {callSpaceUp} from "../../utils/api";
import echart from "echarts";
export default {
  components: {  },
  name: "hpuseStatistics",
  data() {
    return {
        year:'2021',
        yearList:[{
            flex: 1,
            values:["2021"] ,
            className: 'slot1',
            textAlign: 'center'
        }],
        pickList:[{
            flex: 1,
            values:["2021"] ,
            className: 'slot1',
            textAlign: 'center'
        }],
        popupVisible:false,
        option:{
            color: ["#0087ff", "#FFFFFF", "#9D9D9D", "#FFBA6B", "#FE7171"],
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    // 坐标轴指示器，坐标轴触发有效
                    type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                },
                confine: true,
            },
            legend: {
                itemHeight: 10,
                itemWidth: 10,
                data: ["单位(度)"],
                top:30,
                left:55,
            },
            grid: {
                left: 40,
                right: 10,
                bottom: 40,
                top: 40,
                containLabel: false,
            },
            xAxis: {
                type: 'category',
                data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月', '9月', '10月', '11月', '12月'],
                axisLine:{
                    lineStyle: {
                        color: "#999999",
                    },
                },
                 axisTick:{
                     show: false ,
                 },
                axisLabel: {
                    interval: 0,
                    fontSize: 12,
                    rotate:   0,  //type == 1 ? 45 : 0,
                    color: "#999999",
                },
           },
            yAxis: {
                type: 'value',
                name: '单位(度)',
                splitLine: {show: false},
                 axisLine: { // 坐标轴刻度相关设置。
                    show: false ,
                 },
                 axisTick:{
                     show: false ,
                 },
                 min:0,
                scale : true,
                // splitNumber: 5,
                // interval:50,
                boundaryGap : [ 0, 0.2 ]
            },
            series: [{
                data: [],
                type: 'bar',
                name: "用电量",
                stack: "总量",
                // barcategorygap:'20%',
                // barWidth: type == 1 ? 6 : 12,
                barWidth: 18,
                label: {
                    normal: {
                        show: true,
                        position: "top",
                    },
                },
                itemStyle: {
                // emphasis: {
                //   color: '#37a2da'
                // }
                },
            },
            ],
            dataZoom: [
                {
                    type: 'inside',
                    zoomLock: true,
                    start: 0,
                    end: 45
                },
            {
                zoomLock: true,
                handleSize: 0,
                handleColor: 'rgba(255,255,255, 0)',
                handleStyle: {
                    opacity: 0
                },
                fillerColor: '#0087ff',
                backgroundColor: '#F7F7F7',
                borderColor: 'rgba(255,255,255, 0)',
                showDataShadow: false,
                showDetail: false,
                height: 6,
                bottom: 10,
                start: 0,
                end: 45,
                show: true
            }
        ]
        },

       timeout:'',
       biaoList:[],
       allList:[],
       swipeIndex:0,
       selectIntelligence:'',
       intelligenceCode:'' , //表号
       storeNo:'', //单元号

       allAmount:'0',//总金额 ,
       allAmountInt :0,
       allAmountDif :'00',
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  mounted() {
    this.chart = echart.init(this.$refs.chart);
    this.updateChartView();
    window.addEventListener("resize", this.handleWindowResize);
  },
  created() {
     this.initYears()
     this.getDeviceList()
  },
  methods: {
        ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo','getTenantInfoList','getTheme','getHolidayStyle']),
        initYears(){
           var currentDate = new Date();
           var endYear = currentDate.getFullYear();
           var yearList =[];
           endYear =parseInt(endYear);
          // for(var i= endYear ;i>2015;i--){
                yearList.push(endYear);
          // }
           this.yearList[0].values=yearList;
           this.year=endYear;
      },

        getDeviceList() {
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                subProjectIds:this.common.marketInfo.id,
                companyId: this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                page:1,
                pageSize:100,
                spaceName:'',
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                url: "/property/rstRepair/queryDeviceMonitorPage"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   var list =res.body.data.list
                    for(var i=0;i<list.length;i++){
                        var item =list[i];
                        var pitem  =item.prpDeviceSpaceRelBeans
                        if(pitem && pitem.length>0){
                            item.storeNo = pitem[0].subProjectName +'-'+pitem[0].buildName+"-"+pitem[0].spaceName
                        }
                    }
                    this.biaoList =list;
                    if(list.length>0){
                        this.intelligenceCode =list[0].id
                        this.storeNo = list[0].storeNo
                        this.selectIntelligence =this.biaoList[0]
                         this.queryMeterReadMonthCountByDeviceId();
                    }else{
                        util.showToast("没有相关电表数据")
                    }
                    this.updateChartView()
                }
            });
        },

        //获取月用电量
        queryMeterReadMonthCountByDeviceId(){
            var params = {
                 deviceId:this.intelligenceCode,
                 marketId: this.common.marketInfo.id,
                 companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                 merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                 year:this.year,
                 url:"/property/rstRepair/queryMeterReadMonthCountByDeviceId"
             }
             callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                    // var obj =res.body.data
                    // this.syAmount = obj.balance ||0
                    console.log("in ")
                    this.allList = res.body.data;
                    var yearList =[];
                    var year ='';
                    for(var n=0;n<this.allList.length;n++){
                        var nitem = this.allList[n];
                        if(n==0){
                            year = nitem.year;
                        }
                        var hasYear =false
                        for(var k=0;k<yearList.length;k++){
                            if(nitem.year==yearList[k]){
                                hasYear =true;
                                break;
                            }
                        }
                        if(!hasYear){
                            yearList.push(nitem.year)
                        }
                    }
                    this.yearList[0].values=yearList;
                    this.year=year;
                    this.setChartData()

                }
            });

        },

         //刷新图表

        setChartData(){
                var list =[];
                for(var n=0;n<this.allList.length;n++){
                        var nitem = this.allList[n];
                    if(this.year == nitem.year){
                        console.log(" in year===www")
                        list.push(nitem)
                    }
                }
                var num =12;
                if(list.length>12){
                        num =12;
                }else{
                        num =list.length
                }
                var data=[];
                for(var i=0;i<12;i++){
                        data.push('');
                }
                var count =0;
                for(var j=0;j<num;j++){
                        var item = list[j];
                        var month =parseInt(item.month);
                        data[month-1] = item.monthUsage
                        count = count+item.monthUsage
                }
                this.allAmount =count;
                this.allAmountInt =parseInt(count);
                var meterkWh =String(count.toFixed(2)) ;
                    // meterkWh
                    //  meterkWh_l: meterkWh.split(".")[0],
                this.allAmountDif= meterkWh.split(".")[1],
                this.option.series[0].data =data;
                this. updateChartView()
        },
        updateChartView() {
            if (!this.chart) return;
            const fullOption = this.option
            this.chart.setOption(fullOption, true);
        },
        handleChange(index){
            this.swipeIndex =index
            clearTimeout(this.timeout) //防止连续滚动触发
            this.timeout = setTimeout(() => {
                this.swipeIndex =index
                console.log("handleChangeIndex ===  "  + index)
                this.intelligenceCode =this.biaoList[index].id
                this.storeNo = this.biaoList[index].storeNo
                this.selectIntelligence =this.biaoList[index]
                this.queryMeterReadMonthCountByDeviceId()
            }, 500)
        },
        changeSwipeIndex(index){
            // console.log("changeSwipeIndex ===  "  + this.$refs.swipe.index)
            // var swipeIndex = this.$refs.swipe.index; //轮播当前索引
            if (index==1) {
                //if(this.swipeIndex<this.biaoList.length){
                    this.$refs.swipe.next(); // 转到下一张轮播图
                //}
                // this.swipeIndex=this.$refs.swipe.index
            } else if (index==-1) {
               // if(this.swipeIndex>0){
                    this.$refs.swipe.prev(); // 转到前一张轮播图
                //}
                //  this.swipeIndex=this.$refs.swipe.index
            }
            console.log("hpRecharge    === " +  this.swipeIndex)
        },
        handleWindowResize() {
            if (!this.chart) return;
            this.chart.resize();
        },


    showPickView(){
        console.log("in showPickView")
        this.popupVisible=true;
        this.pickList = this. yearList;
     },
     onValuesChange (picker, values) {
        if (values[0] > values[1]) {
            picker.setSlotValue(1, values[0]);
        }
     },

    handleConfirm(){
        this.popupVisible = false
        var valve =  this.$refs.picker.getValues()[0];
        this.year=valve;
        this.setChartData();
       // this.queryMeterReadMonthCountByDeviceId()

    },

    beforeDestroy() {
        window.removeEventListener("resize", this.handleWindowResize);
    },
    toUseDetailed(){
        this.$router.push('/hpuseDetailed');
    },
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
  background: #F3F4F6;
  flex-direction: column;
}
.topBg{
    flex-direction: column;
    position: relative;
    width: 750px;
    height: 322px;
    background: #FFFFFF;
}

//轮播图
.swiper_bg{
    margin-top: 28px;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    height: 266px;
    background: linear-gradient(270deg, #FFBE00 0%, #FFA100 100%);
    box-shadow: 0px 8px 24px 0px #FFEAC8;
    border-radius: 12px;
    flex-direction: column;
}
.swiper_top{
    width: 694px;
    display: flex;
    height: 136px;
    flex-direction: column;
    position: relative;
}
.swiper_top_item1{
    width: 694px;
    display: flex;
    height: 40px;
    margin-top: 28px;
    flex-direction: row;
}
.swiper_top_item2{
    width: 694px;
    height: 40px;
    display: flex;
    margin-top: 8px;
    flex-direction: row;
}
.swiper_top_span1{
    margin-left: 28px;
    width: 100px;
    display: flex;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span2{
    width: 452px;
    height: 40px;
    display: flex;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span3{
    position: absolute;
    right: 28px;
    top:28px;
    height: 32px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
}
.swiper_footer{
    width: 694px;
    height: 130px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
}
.swiper_top_span4{
     width: 638px;
    margin-top: 20px;
    margin-left: 28px;
    height: 34px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
}
.swiper_top_span5{
     margin-top: 8px;
    margin-left: 28px;
    width: 638px;
    height: 40px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
// 箭头。
.prevIcon{
    position: absolute;
    left: 20px;
    top: 130px;
    width: 44px;
    height: 44px;
    display: block;

}
.nextIcon{
    position: absolute;
    right: 20px;
    top: 130px;
    width: 44px;
    height: 44px;
    display: block;
}

// chooseview

.chooseview{
    position: relative;
    margin-top: 14px;
    width: 750px;
    height: 88px;
    background: #FFFFFF;
    flex-direction: row;
    display: flex;
    justify-content: center;
    align-items: center;
}
.chooseSpan{
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 44px;
}
.chooseIcon{
    width: 24px;
    height: 24px;
    margin-left: 10px;
}
.chooseDiv{
    position: absolute;
    right: 28px;
    top: 22px;
    flex-direction: row;
}
.chooseSpan1{
    height: 44px;
    font-size: 26px;
    font-weight: 400;
    color: #999999;
    line-height: 44px;
}
.chooseIcon1{
    width: 24px;
    height: 24px;
    margin-left: 10px;
}
//yearAmountView
.yearAmountView{
    width: 750px;
    height: 250px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}
.yearAmountSpan1{
    width: 750px;
    text-align: center;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
    margin-top: 40px;
}
.yearAmountdiv{
    margin-top: 14px;
    width: 750px;
    flex-direction: row;
    justify-content: center;
    display: flex;
}
.yearAmountSpan2{
    height: 96px;
    font-size: 68px;
    font-weight: 400;
    color: #333333;
    line-height: 96px;
}
.yearAmountSpan3{
    margin-top: 40px;
    height: 40px;
    font-size: 28px;
    color: #333333;
    line-height: 40px;
}
//barView
.barViewBg{
    width: 750px;
    height: 440px;
    background-color: #ffffff;
    display: flex;
}
.chart{
    width: 100%;
    height: 100%;
}

////pick
.picker {
    width:100%;
}
.picker-items {
    height: 100px!important;
}
.picker_wrap {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 28px;
    box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
    flex: 1;
    font-size: 32px;
    text-align: left;
    line-height: 100px;
}
.picker_btn2 {
    text-align: right;
    color: @color17;
}


</style>